import React from "react";

const SurveyCompletedScreen = () => (
  <>
    <h2 className="text-center">
      Usted ya completó este formulario, no lo puede volver a responder.
    </h2>
  </>
);

export default SurveyCompletedScreen;
